// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/**
 * Документ
 */
html,
body,
#root {
  width: 100%;
  height: 100%;
}

:root {
  --schedule-employee-column-width: 134px;
  --schedule-day-width: clamp(36px, calc((100vw - 134px) / 31), 46px);
  --schedule-row-height: clamp(26px, calc((100vh - 72px) / 10), 42px);
  --schedule-bottom-safe-area: max(36px, env(safe-area-inset-bottom));
}

body {
  margin: 0;
  padding: 0;
  overflow: hidden;
  background-color: #fff;
}

/**
 * Обычная ячейка
 */
.table__cell {
  border: 1px solid rgba(0, 0, 0, 0.65);
  box-sizing: border-box;
  padding: 0 4px;
  width: 100%;
  min-width: 0;
  min-height: var(--schedule-row-height);
  height: var(--schedule-row-height);
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.table__cell_special {
  box-sizing: border-box;
  width: var(--schedule-day-width);
  min-width: var(--schedule-day-width);
  max-width: var(--schedule-day-width);
}

.month_block {
  flex: 0 0 auto;
}

.schedule_data {
  width: max-content;
}

/**
 * Цвета занятости
 */
.work_code__kar {
  font-weight: bold;
  background: #6aa84f;
  color: white;
}

.work_code__tru {
  font-weight: bold;
  background: transparent;
  color: white;
}

.work_code__vac {
  font-weight: bold;
  background: #ea9999;
  color: white;
}

.work_code__tou {
  font-weight: bold;
  background: #8e7cc3;
  color: white;
}

.work_code__tra {
  font-weight: bold;
  background: #ff00ff;
  color: white;
}

.work_code__out {
  font-weight: bold;
  background: transparent;
  color: white;
}

.work_code__emp {
  background: transparent;
}

.work_code__emp--button {
  background: white;
}

/**
 * Календарь
 */
.no-link {
  color: black;
  text-decoration: none;
}
.no-link:focus, .no-link:hover, .no-link:visited, .no-link:link, .no-link:active {
  text-decoration: none;
}

.fc {
  /* the calendar root */
  height: 100%;
  margin: 0 auto;
}`, "",{"version":3,"sources":["webpack://./src/styles/styles.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB;;EAAA;AAGA;;;EAGE,WAAA;EACA,YAAA;AAEF;;AACA;EACE,uCAAA;EACA,mEAAA;EACA,mEAAA;EACA,mEAAA;AAEF;;AACA;EACE,SAAA;EACA,UAAA;EACA,gBAAA;EACA,sBAAA;AAEF;;AACA;;EAAA;AAGA;EACE,qCAAA;EACA,sBAAA;EACA,cAAA;EACA,WAAA;EACA,YAAA;EACA,sCAAA;EACA,kCAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;AAEF;;AACA;EACE,sBAAA;EACA,gCAAA;EACA,oCAAA;EACA,oCAAA;AAEF;;AACA;EACE,cAAA;AAEF;;AACA;EACE,kBAAA;AAEF;;AACA;;EAAA;AAGA;EACE,iBAAA;EACA,mBAAA;EACA,YAAA;AAEF;;AACA;EACE,iBAAA;EACA,uBAAA;EACA,YAAA;AAEF;;AACA;EACE,iBAAA;EACA,mBAAA;EACA,YAAA;AAEF;;AACA;EACE,iBAAA;EACA,mBAAA;EACA,YAAA;AAEF;;AACA;EACE,iBAAA;EACA,mBAAA;EACA,YAAA;AAEF;;AACA;EACE,iBAAA;EACA,uBAAA;EACA,YAAA;AAEF;;AACA;EACE,uBAAA;AAEF;;AACA;EACE,iBAAA;AAEF;;AACA;;EAAA;AAGA;EACE,YAAA;EACA,qBAAA;AAEF;AAAE;EACE,qBAAA;AAEJ;;AAEA;EACE,sBAAA;EACA,YAAA;EACA,cAAA;AACF","sourcesContent":["/**\n * Документ\n */\nhtml,\nbody,\n#root {\n  width: 100%;\n  height: 100%;\n}\n\n:root {\n  --schedule-employee-column-width: 134px;\n  --schedule-day-width: clamp(36px, calc((100vw - 134px) / 31), 46px);\n  --schedule-row-height: clamp(26px, calc((100vh - 72px) / 10), 42px);\n  --schedule-bottom-safe-area: max(36px, env(safe-area-inset-bottom));\n}\n\nbody {\n  margin: 0;\n  padding: 0;\n  overflow: hidden;\n  background-color: #fff;\n}\n\n/**\n * Обычная ячейка\n */\n.table__cell {\n  border: 1px solid rgba(0, 0, 0, 0.65);\n  box-sizing: border-box;\n  padding: 0 4px;\n  width: 100%;\n  min-width: 0;\n  min-height: var(--schedule-row-height);\n  height: var(--schedule-row-height);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n}\n\n.table__cell_special {\n  box-sizing: border-box;\n  width: var(--schedule-day-width);\n  min-width: var(--schedule-day-width);\n  max-width: var(--schedule-day-width);\n}\n\n.month_block {\n  flex: 0 0 auto;\n}\n\n.schedule_data {\n  width: max-content;\n}\n\n/**\n * Цвета занятости\n */\n.work_code__kar {\n  font-weight: bold;\n  background: #6aa84f;\n  color: white;\n}\n\n.work_code__tru {\n  font-weight: bold;\n  background: transparent;\n  color: white;\n}\n\n.work_code__vac {\n  font-weight: bold;\n  background: #ea9999;\n  color: white;\n}\n\n.work_code__tou {\n  font-weight: bold;\n  background: #8e7cc3;\n  color: white;\n}\n\n.work_code__tra {\n  font-weight: bold;\n  background: #ff00ff;\n  color: white;\n}\n\n.work_code__out {\n  font-weight: bold;\n  background: transparent;\n  color: white;\n}\n\n.work_code__emp {\n  background: transparent;\n}\n\n.work_code__emp--button {\n  background: white;\n}\n\n/**\n * Календарь\n */\n.no-link {\n  color: black;\n  text-decoration: none;\n\n  &:focus, &:hover, &:visited, &:link, &:active {\n    text-decoration: none;\n  }\n}\n\n.fc {\n  /* the calendar root */\n  height: 100%;\n  margin: 0 auto;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
